import api from './api';

export interface UserCredits {
  totalCredits: number;
  usedCredits: number;
  remainingCredits: number;
  maxProjects: number;
  currentProjectCount: number;
  canCreateProject: boolean;
  hasCredits: boolean;
}

export interface Profile {
  user: { id: string; name: string; email: string };
  projects: { id: string; name: string; version: string; thumbnailUrl?: string }[];
  credits: UserCredits;
}

export async function getProfile(): Promise<Profile> {
  const { data } = await api.get<Profile>('profile');
  return data;
}
